import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const useAuthenticationFirewallEnabled = (): boolean => {
    const { isPageBlocked } = usePricingModulesState();

    return !isPageBlocked(LAYOUT_TABS.AUTHENTICATION_FIREWALL_DASHBOARD.ID);
};
